<template>
  <div class="page">
    <img src="../../assets/images/logintop.png" class="topimg" alt="">
    <div class="main">
      <div class="inputarea">
        <img src="../../assets/images/phone.png" class="sicon" alt="">
        <input type="text" v-model="phone" class="input" placeholder="请输入手机号">
      </div>
      <div class="inputarea" style="margin: .8rem 0;">
        <img src="../../assets/images/code.png" class="sicon" alt="">
        <input type="text" v-model="code" maxlength="6" class="input1" placeholder="请输入验证码">
        <button v-if="!isDisabled" class="sendcode" @click="sendcode()">发送验证码</button>
        <button v-if="isDisabled" class="sendcode" disabled>{{ countdown }}秒后可用</button>
      </div>
      <div class="checkarea">
        <el-checkbox v-model="checked" class="checked">我已阅读并同意</el-checkbox><span class="red"
          @click="xieyidia()">《用户服务协议》</span>
      </div>
      <button class="login" @click="login()">登录</button>
    </div>
    <van-dialog v-model="showxieyi" title="《用户服务协议》" show-cancel-button @confirm="hdxieyiyes()" class="diaheight">
      <div style="padding:15px">
        <p>一、特别提示</p>
        <p>您（用户）在注册成为华肤荟用户之前，请仔细阅读本《华肤荟用户协议》（以下简称“协议”）的全部条款，并确认您已完全充分理解本协议之规定。如您对协议有任何疑问，请立即停止注册，并可向华肤荟客服咨询。</p>
        <p>
          华肤荟有权利对本协议进行修改，协议修改后，华肤荟将在相关页面公布修改的内容，修改后的协议一经公布即有效的代替原协议。如果您不同意本协议的修改，请立即停止访问或使用本网站或取消已经获得的服务；如果您选择在本协议修改后继续访问或使用本网站，则视为您已接受本协议的修改。
        </p>
        <p>华肤荟公布的其他声明、规则等均视为本协议之补充协议，为本协议不可分割的组成部分，与本协议具有同等法律效力。</p>
        <p>二、账号注册</p>
        <p>
          用户在使用本服务前需要注册一个“华肤荟”账号。“华肤荟”账号应当使用手机号码绑定注册，请用户使用尚未与“华肤荟”账号绑定的手机号码，以及未被华肤荟根据本协议封禁的手机号码注册“华肤荟”账号。华肤荟可以根据用户需求或产品需要对账号注册和绑定的方式进行变更，而无须事先通知用户。
        </p>
        <p>如果注册申请者有被华肤荟封禁的先例或涉嫌虚假注册及滥用他人名义注册，及其他不能得到许可的理由，华肤荟将拒绝其注册申请。</p>
        <p>鉴于“华肤荟”账号的绑定注册方式，您同意华肤荟在注册时将允许您的手机号码及手机设备识别码等信息用于注册。</p>
        <p>
          在用户注册及使用本服务时，华肤荟需要搜集能识别用户身份的个人信息以便华肤荟可以在必要时联系用户，或为用户提供更好的使用体验。华肤荟搜集的信息包括但不限于用户的姓名、地址；华肤荟同意对这些信息的使用将受限于第三条用户个人隐私信息保护的约束。
        </p>
        <p>三、用户声明与保证</p>
        <p>用户承诺其为具有完全民事行为能力的民事主体，且具有达成交易履行其义务的能力。</p>
        <p>用户有义务在注册时提供自己的真实资料，并保证诸如手机号码、姓名等内容的有效性及安全性，保证华肤荟工作人员可以通过上述联系方式与用户取得联系。同时，用户也有义务在相关资料实际变更时及时更新有关注册资料。</p>
        <p>用户通过使用华肤荟的过程中所上载、复制、发布、传播的任何内容，或文字、语音、图片、视频、图文等发送、回复和相关链接页面，以及其他使用账号或本服务所产生的内容，不得违反国家相关法律制度，包含但不限于如下原则：
        </p>
        <p>违反宪法所确定的基本原则的；</p>
        <p>危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
        <p>损害国家荣誉和利益的；</p>
        <p>煽动民族仇恨、民族歧视，破坏民族团结的；</p>
        <p>破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
        <p>散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
        <p>散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
        <p>侮辱或者诽谤他人，侵害他人合法权益的；</p>
        <p>含有法律、行政法规禁止的其他内容的。</p>
        <p>用户不得利用“华肤荟”账号或本服务制作、上载、复制、发布、传播下干扰“华肤荟”正常运营，以及侵犯其他用户或第三方合法权益的内容：</p>
        <p>含有辱骂、恐吓、威胁内容的；</p>
        <p>含有骚扰、垃圾广告、恶意信息、诱骗信息的；</p>
        <p>涉及他人隐私、个人信息或资料的；</p>
        <p>侵害他人名誉权、肖像权、知识产权、商业秘密等合法权利的；</p>
        <p>含有其他干扰本服务正常运营和侵犯其他用户或第三方合法权益内容的信息。</p>
        <p>四、服务内容</p>
        <p>华肤荟为广大用户提供技术服务、学术推广服务等多方面的服务。华肤荟为平台，不保证其提供的服务一定满足用户的全部需求。华肤荟保留随时修改、中断或终止服务且无需通知用户的权利，无需对用户或任意第三方承担任何责任。</p>
        <p>华肤荟有权随时审核或删除用户发布/传播的涉嫌违法或违反社会主义精神文明，或者被华肤荟认为不妥当的内容（包括但不限于文字、语音、图片、视频、图文等）。</p>
        <p>六、服务的终止</p>
        <p>在下列情况下，华肤荟有权终止向用户提供服务：</p>
        <p>在用户违反本服务协议相关规定时，华肤荟有权终止向该用户提供服务；如该用户再一次直接或间接或以他人名义注册为用户的，一经发现，华肤荟有权直接单方面终止向该用户提供服务；</p>
        <p>用户不得通过程序或人工方式进行刷量或作弊，若发现用户有作弊行为，华肤荟将立即终止服务，并有权扣留账户内金额；</p>
        <p>一旦华肤荟发现用户提供的数据或信息中含有虚假内容，华肤荟有权随时终止向该用户提供服务；</p>
        <p>本服务条款终止或更新时，用户明示不愿接受新的服务条款；</p>
        <p>其它华肤荟认为需终止服务的情况。</p>
        <p>服务终止后，华肤荟没有义务为用户保留原账号中或与之相关的任何信息，或转发任何未曾阅读或发送的信息给用户或第三方。</p>
        <p>用户理解并同意，即便在本协议终止及用户的服务被终止后，华肤荟仍有权：</p>
        <p>继续保存您的用户信息；</p>
        <p>继续向用户主张在其使用百姓网平台服务期间因违反法律法规、本协议及平台规则而应承担的责任。</p>
        <p>七、服务的变更、中断</p>
        <p>鉴于网络服务的特殊性，用户需同意华肤荟会变更、中断部分或全部的网络服务，并删除（不再保存）用户在使用过程中提交的任何资料，而无需通知用户，也无需对任何用户或任何第三方承担任何责任。
        </p>
        <p>华肤荟需要定期或不定期地对提供网络服务的平台进行检测或者更新，如因此类情况而造成网络服务在合理时间内的中断，华肤荟无需为此承担任何责任。</p>
        <p>八、服务条款修改</p>
        <p>华肤荟有权随时修改本服务条款的任何内容，一旦本服务条款的任何内容发生变动，华肤荟将会通过适当方式向用户提示修改内容。</p>
        <p>如果不同意华肤荟对本服务条款所做的修改，用户有权停止使用网络服务。</p>
        <p>如果用户继续使用网络服务，则视为用户接受华肤荟对本服务条款所做的修改。</p>
        <p>九、免责与赔偿声明</p>
        <p>若华肤荟已经明示其服务提供方式发生变更并提醒用户应当注意事项，用户未按要求操作所产生的一切后果由用户自行承担。</p>
        <p>用户明确同意其使用华肤荟所存在的风险将完全由其自己承担，因其使用华肤荟而产生的一切后果也由其自己承担。</p>
        <p>用户同意保障和维护华肤荟及其他用户的利益，由于用户在使用华肤荟有违法、不真实、不正当、侵犯第三方合法权益的行为，或用户违反本协议项下的任何条款而给华肤荟及任何其他第三方造成损失，用户同意承担由此造成的损害赔偿责任。
        </p>
        <p>十、隐私声明</p>
        <p>适用范围：</p>
        <p>在用户注册华肤荟账户时，根据要求提供的个人注册信息；</p>
        <p>在用户使用华肤荟，或访问其相关网页时，华肤荟自动接收并记录的用户浏览器上的服务器数值，包括但不限于IP地址等数据及用户要求取用的网页记录。</p>
        <p>信息使用：</p>
        <p>华肤荟不会向任何人出售或出借用户的个人信息，除非事先得到用户的许可；</p>
        <p>华肤荟亦不允许任何第三方以任何手段收集、编辑、出售或者无偿传播用户的个人信息。任何用户如从事上述活动，一经发现，华肤荟有权立即终止与该用户的服务协议，查封其账号；</p>
        <p>为达到服务用户的目的，华肤荟可能通过使用用户的个人信息，向用户提供服务，包括但不限于向用户发出产品和服务信息，或者与华肤荟合作伙伴共享信息以便他们向用户发送有关其产品和服务的信息。</p>
        <p>信息披露：用户的个人信息将在下述情况下部分或全部被披露：</p>
        <p>经用户同意，向第三方披露；</p>
        <p>根据法律的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；</p>
        <p>如果用户出现违反中国有关法律或者网站政策的情况，需要向第三方披露；</p>
        <p>为提供用户所要求的产品和服务，而必须和第三方分享用户的个人信息；</p>
        <p>其它华肤荟根据法律或者网站政策认为合适的披露；</p>
        <p>用户使用华肤荟时提供的银行账户信息，华肤荟将严格履行相关保密约定。</p>
        <p>十一、其他</p>
        <p>本协议的效力、解释及纠纷的解决，适用于中华人民共和国法律。若用户和华肤荟之间发生任何纠纷或争议，首先应友好协商解决。</p>
        <p>本协议的任何条款无论因何种原因无效或不具可执行性，其余条款仍有效，对双方均具有约束力。</p>
        <p>本协议最终解释权归华肤荟本协议从2025年1月1日起适用</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import storage from "../../common/utils/storage";
import { Dialog } from 'vant';
import { showConfirmDialog } from 'vant';
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
  },
  name: 'login',
  data() {
    return {
      phone: "",
      code: "",
      checked: false,
      countdown: 60,
      timer: null,
      isDisabled: false,
      showxieyi: false,
    }
  },
  computed: {
    ...mapState(['Openid', 'userInfo']),
    sid() {
      return this.$route.query.sid;
    },
    uri() {
      return this.$route.query.uri;
    }
  },
  created() {
    document.title = "华肤荟";
    if (!this.userInfo || this.userInfo.Status < 20) {
      storage.setStore('scope', 'snsapi_userinfo');
      this.$router.push({
        path: '/authorize',
        query: { scope: 'snsapi_userinfo' }
      })
    }
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer); // 组件销毁前清除定时器，防止内存泄漏
    }
  },
  methods: {
    startCountdown() {
      this.isDisabled = true; // 禁用按钮
      this.countdown = 60; // 设置倒计时时间
      this.timer = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1; // 倒计时减1
        } else {
          clearInterval(this.timer); // 清除定时器
          this.isDisabled = false; // 重新启用按钮
        }
      }, 1000); // 每秒更新一次倒计时
    },
    sendcode() {
      // console.log(this.phone)
      if (this.phone.length != 11) {
        Dialog.alert({
          message: '请输入正确的手机号码',
        }).then(() => {
          // on close
          this.startCountdown()
        });
      } else {
        this.$axios.get('/api/api/web/Customer/GetVCode?mobile=' + this.phone).then(res => {
          Dialog.alert({
            message: '发送成功！',
          }).then(() => {
            // on close
            this.startCountdown()
          });
        }).catch(error => {
          Dialog.alert({
            message: '发送失败，请确认手机号码正确后重新尝试',
          }).then(() => {
            // on close
          });
        });
      }
      // return false
    },
    xieyidia() {
      this.showxieyi = true
    },
    hdxieyiyes() {
      this.showxieyi = false;
      this.checked = true
    },
    login() {
      let that = this
      if (this.checked && this.phone.length == 11) {
        this.$axios.post('/api/api/web/Customer/Register', {
          Mobile: this.phone,
          Vcode: this.code
        }).then(res => {
          Dialog.alert({
            message: '登录成功！',
          }).then(() => {
            sessionStorage.setItem('userInfo', JSON.stringify(res.Data.BaseInfo));
            if (res.Data.BaseInfo.Status == 40) {
              let redirectUrl = sessionStorage.getItem("redirectUrl");
              if (redirectUrl && !that.$route.query.dkid) {
                this.$router.push(redirectUrl);
                sessionStorage.removeItem('redirectUrl');
              } else if (redirectUrl && that.$route.query.dkid) {
                this.$router.push(redirectUrl + "&dkid=" + that.$route.query.dkid);
                sessionStorage.removeItem('redirectUrl');
              } else {
                this.$router.push({
                  path: 'mine',
                })
              }
            } else {
              if (that.$route.query.dkid) {
                this.$router.push({
                  path: 'compinfo',
                  query: {
                    dkid: that.$route.query.dkid
                  }
                })
              } else {
                this.$router.push({
                  path: 'compinfo',
                })
              }
            }
          });
        }).catch(error => {
          // console.log(error)
          const cleanError = error.toString().replace('Error: ', '');
          console.log(cleanError);
          Dialog.alert({
            message: cleanError,
          }).then(() => {
            // on close
          });
        });
      } else if (!this.checked) {
        Dialog.alert({
          message: '请阅读并同意《用户服务协议》、《用户隐私使用协议》',
        }).then(() => {
          // on close
        });
      } else if (this.phone.length != 11) {
        Dialog.alert({
          message: '请输入正确的手机号码',
        }).then(() => {
          // on close
        });
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.topimg {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 1;
}

.page {
  background: rgb(247, 248, 252);
  width: 100%;
  height: 100%;
}

.main {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
  top: 20%;
  width: 90%;
}

.inputarea {
  background: #fff;
  border-radius: 10px;
  box-sizing: border-box;
  padding: 10px 0;
}

.sicon {
  display: inline-block;
  vertical-align: middle;
  width: 6%;
  padding: 1% 5%;
  border-right: 1px solid #ddd;
}

.input {
  vertical-align: middle;
  display: inline-block;
  border: 0;
  box-sizing: border-box;
  font-size: 0.48rem;
  width: 80%;
  padding: 0 20px;
}

.input1 {
  vertical-align: middle;
  display: inline-block;
  border: 0;
  box-sizing: border-box;
  font-size: 0.48rem;
  width: 56%;
  padding: 0 20px;
}

.sendcode {
  padding: 3px 6px;
  vertical-align: middle;
  font-size: 14px;
  border: 0;
  background: #1d2a5a;
  color: #fff;
  border-radius: 5px;
}

.checkarea {
  font-size: .33rem;
}

.checked {
  // margin-right: 0.15rem;
}

::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #1d2a5a;
  border-color: #1d2a5a;
  border-radius: 50px;
}

::v-deep .el-checkbox__inner {
  border-radius: 50px !important;
}

::v-deep .el-checkbox__label {
  font-size: 0.33rem;
  color: #0C2941
}

.red {
  color: red;
  font-size: .31rem !important;
}

::v-deep .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #0C2941
}

.login {
  margin: auto;
  margin-top: 1rem;
  display: block;
  width: 90%;
  padding: 0.3rem 0;
  font-size: .43rem;
  border: 0;
  background: #1d2a5a;
  color: #fff;
  border-radius: 50px;
}

.diaheight {
  z-index: 2002;
  height: 70%;
  overflow-y: scroll;
}
</style>